import ReactDOM from 'react-dom';
import stateData from './data.state';
//import keys from './keys';

import {  CalciteRadioGroup, CalciteRadioGroupItem } from "@esri/calcite-components-react";

const compileDiseases =  (value, key, data) => {	
	console.log('compileDiseases', value, key, data);

	if( !value 
	) {
		return 'No Pathogen Data is available for this state.';
	}

	const myJson = JSON.parse(value);
// Should be "Shellfish Produced", 
//"Pathogens Present" (broken out by "Detected Through Monitoring Data" and "Historical/Anecdotal Occurrence"), and 
//"Monitoring Data" (broken out by species with a list of pathogens we have data for and date range for each)

	const myDetected = myJson.detected;
	const myHistorical = myJson.historical;

	if( Object.keys(myDetected).length === 0 && myHistorical.length ===0 ) {
		return 'No Pathogen Data is available for this state.';
	}
	
	console.log('[statepopup]', myDetected);
	const detectedHtml = `<h4 style="margin-bottom:.5rem;">Detected Through Monitoring Data</h4><ul style="padding-left:1.5rem;">${Object.keys(myDetected).map( (detectedSpecies)=>{

		return `<li>${detectedSpecies} <ul style="padding-left:1rem;">${myDetected[detectedSpecies].map( (speciesInfo) => { 
			return `<li>${speciesInfo.pathogen}</li>`;
		}).join('')}</ul></li>`;
		
	}).join('')}</ul>`;
	/*
	const detectedHtml = `<h4 style="margin-bottom:.5rem;">Detected Through Monitoring Data</h4><ul>${Object.keys(myDetected).map( (detectedPatho)=>{

		return `<li>${detectedPatho} <ul>${myDetected[detectedPatho].map( (species) => { 
			return `<li>${species}</li>`;
		})}</ul></li>`;
		
	}).join('')}</ul>`;
*/


	const historicalHtml = `<h4 style="margin-bottom:.5rem;">Historical / Anecdotal Occurrence</h4><ul style="padding-left:1.5rem;">${myHistorical.map( (historicalPatho)=>{
		return `<li>${historicalPatho}</li>`;
	}).join('')}</ul>`;

	return `
	${
		Object.keys(myDetected).length > 0
		?
		detectedHtml
		: ''

	}
	${
		myHistorical.length > 0
		?
		historicalHtml
		: ''

	}
	`;

/*
	Object.keys(myJson).forEach( (myPathogenKey) => {
		if( myJson[myPathogenKey] ==
	});
	return `<ul>${
		if( myJson[myPathogenKey] > 0 ) {

			return `<li>${myPathogenKey}${
				myJson[myPathogenKey] === 2 ? 
				' <strong><em>*Potentially</em></strong>' : ''
			}</li>`;
		}
		return null;
	}).filter( (removeNulls) => { return removeNulls !== null }).join('')}</ul>`;
*/
	/*
	let myData = stateData.payload[value];
	let myDiseases = [];
	let recordVars = [

		'Bonamia',
		'Chlamydial_Ricketsial',
		'Clam_Perkinsus',
		'Dermo',
		'Digenean_trematodes',
		'Gonadal_neoplasia',
		'Hemocytic_neoplasia',
		'Hinge_lingament',
		'MSX',
		'Mussel_egg',
		'Oyster_Herpes',
		//'Pea_crabs',
		'QPX',
		'ROD_JOD',
		'SSO',
		'Vibrosis',
		'Xenomas'
	];
	for(let i=0;i<recordVars.length;i++){
		switch(myData[recordVars[i]]) {
			case '1':
				myDiseases.push( '<li>' + recordVars[i].replace('_', ' ') + '</li>' )
				break;
			case '2':
				myDiseases.push( '<li>' + recordVars[i].replace('_', ' ') + ' <strong><em>*Potentially</em></strong></li>' )
				break;
			case '-1':
			default:
				//Do not add
				break;
		}
	}
	
	return myDiseases.join('');
	*/
}

				
const compileShellfish = (value, key, data)=> {
	console.log('compileShellfish', value, key, data);	
	
	if( !value ) {
		return 'No Shellfish Produced Data is available for this state.';
	}

	const myJson = JSON.parse(value);

	return `${Object.keys(myJson).map( (myWaterType) => {
		return `<div class="col-md-4"> 
			<span><strong><em>${myWaterType}</em></strong></span>
			<ul>
				${myJson[myWaterType].map( (mySpeciesNames) => { 
					return `<li>${mySpeciesNames}</li>`;
				}).join('')}
			</ul>
		</div>`;

		
	}).filter( (removeNulls) => { return removeNulls !== null }).join('')}`;
	/*
	return '';		
	let mySpecies = stateData.payload[value].species;
	let compileHTML =[];
	let ignoreVars = [
		'state_species_data_id',
		'statefp',
		'state_order'
	];

	for(let i in mySpecies ){
		let mySpRegionSet = mySpecies[i];
		compileHTML.push('<div class="col-md-4"> <span><strong><em>'+ i +'</em></strong></span><ul>');
		console.log(mySpRegionSet);
		for(let j in mySpRegionSet){
			if( ignoreVars.indexOf(j) !== -1 ) { continue; }
			
			switch(mySpRegionSet[j]) {
				case '1':
					compileHTML.push( '<li>' + j.replace('_', ' ') + '</li>' )
					break;
				case '2':
					compileHTML.push( '<li>' + j.replace('_', ' ') + ' <strong><em>*Potentially</em></strong></li>' )
					break;
				case '-1':
				default:
					//Do not add
					break;
			}
		}
		compileHTML.push('</ul></div>');
	}

	return compileHTML.join('');
	*/
}


const compileMonitoring =  (value, key, data) => {
	console.log('compileMonitoring', value, key, data);

	if( !value ) {
		return 'No Monitoring Data available.';
	}

	const myJson = JSON.parse(value.monitoringData);
	const myHeader = `${
		`${value.overall_sites !== null ? `<p style="margin:.25rem 0;"><strong>Overall Monitoring Locations</strong>: ${value.overall_sites}</p>` : ''}
		${value.earliest_date !== null && value.latest_date !== null ? `<p style="margin:.25rem 0;"><strong>Date Range</strong>: ${value.earliest_date || 'N/A'} - ${value.latest_date || 'N/A'}</p>` : ''}`
	}`;

	return myHeader + Object.keys(myJson).map( (shellfishName) => {
		return `<h4 style="margin-bottom:.5rem;">${shellfishName}</h4><ul style="padding-left:1.5rem;">${
			myJson[shellfishName].map( (patho) => {
				return `<li>${patho.pathogen}${
				( patho.additionalInfo ? 
					`<ul style="padding-left:1rem;">
					<li><strong>Monitoring Locations</strong>: ${patho.additionalInfo.num_monitoring_locations || 'N/A'}</li>
					<li><strong>Date Range</strong>: ${patho.additionalInfo.earliest_date || 'N/A'} - ${patho.additionalInfo.latest_date || 'N/A'}</li>
					</ul>` : ``)	
				}</li>`;
			}).join('')
		}</ul>`
	}).join('');
/*
	let compileHTML = [];

	compileHTML.push('<h4><strong><em>Monitoring Regions</em></strong></h4>');
	compileHTML.push('<p><em>(Click Region to zoom to area and view data)</em></p>');

	let myStateData = stateData.payload[value] ;

	for(let i in myStateData.availableBays){
		let myBayInfo = myStateData.availableBays[i];
		compileHTML.push('<p><a href="#" onclick="shellfishHelper.events.showStateBayManual(\''+myBayInfo.key+'\');return false">'+ myBayInfo.name +'</a></p>');
		/*
		compileHTML.push('<ul>');
		for(let j in myBayInfo.diseases){
			compileHTML.push('<li>'+myBayInfo.diseases[j]+'</li>');
		}
		compileHTML.push('</ul>');
		* /
	}




	return compileHTML.join('');
	*/
}

export const stateLayerPopup = (target) => {
	console.log('target', target, stateData);
	console.log('target.graphic', target.graphic);
	const myElement = document.createElement('div');
	const myButtons = document.createElement('div');
	const myDiseases = document.createElement('div');
	const myShellfishProduced = document.createElement('div');
	const myMonitoringData = document.createElement('div');


	myShellfishProduced.style.display='none';
	myMonitoringData.style.display='none';

	ReactDOM.render(
	<CalciteRadioGroup>
		<CalciteRadioGroupItem value="diseases-present" checked onClick={()=>{
			console.log('Pathogens Present');
			myDiseases.style.display='block';
			myShellfishProduced.style.display='none';
			myMonitoringData.style.display='none';}}>Pathogens Present</CalciteRadioGroupItem>
		<CalciteRadioGroupItem value="shellfish-produced" onClick={()=>{console.log('Shellfish Produced');
			myDiseases.style.display='none';
			myShellfishProduced.style.display='block';
			myMonitoringData.style.display='none';}}>Shellfish Produced</CalciteRadioGroupItem>
		<CalciteRadioGroupItem value="monitoring-data" onClick={()=>{console.log('Monitoring Data');
			myDiseases.style.display='none';
			myShellfishProduced.style.display='none';
			myMonitoringData.style.display='block';}}>Monitoring Data</CalciteRadioGroupItem>
	</CalciteRadioGroup>
	, myButtons);

	console.log('x');
			console.log('Comma?',  compileDiseases( target.graphic.attributes.pathogensPresent ));

			console.log('y');
console.log('Starting: My Diseases');			
	myDiseases.innerHTML = compileDiseases( target.graphic.attributes.pathogensPresent );
console.log('Done: My Diseases');

console.log('Starting: My Shellfish produced');			
	myShellfishProduced.innerHTML = compileShellfish( target.graphic.attributes.shellfishProduced );
console.log('Done: My Diseases');

console.log('Starting: My monitoring data');			
	myMonitoringData.innerHTML = compileMonitoring( {
		overall_sites: target.graphic.attributes.overall_sites,
		earliest_date: target.graphic.attributes.earliest_date,
		latest_date: target.graphic.attributes.latest_date,
		monitoringData: target.graphic.attributes.monitoringData
	 } );
console.log('Done: My Diseases');

	
	myElement.append(myButtons);
	myElement.append(document.createElement('hr'));
	console.log('My Disease ? ', myDiseases, myDiseases.innerHTML);


	myElement.append(myDiseases);
	myElement.append(myShellfishProduced);
	myElement.append(myMonitoringData);
	if( target.graphic.attributes.STUSPS === 'GA' ) {
		console.log('Georgia',myElement)

	}
	return myElement;
}